import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  rewardList: {
    requesting: false,
    items: [],
    pagination: {
      current_page: 1,
      per_page: 10,
      total: 0,
    },
    error: null,
    success: false,
    filters: {},
  },
  rewardDetails: {
    requesting: false,
    data: null,
    error: null,
    success: false,
  },
  autoRewardList: {
    requesting: false,
    items: [],
    pagination: {
      current_page: 1,
      per_page: 10,
      total: 0,
    },
    error: null,
    success: false,
    filters: {},
  },
  unautoRewardList: {
    requesting: false,
    items: [],
    pagination: {
      current_page: 1,
      per_page: 10,
      total: 0,
    },
    error: null,
    success: false,
    filters: {},
  },
}

export const rewardSlice = createSlice({
  name: 'reward',
  initialState,
  reducers: {
    getRewardList: (state, action) => {
      state.rewardList.requesting = true
      state.rewardList.error = null
      state.rewardList.items = []
      state.rewardList.success = false
      state.rewardList.filters = action.payload
    },
    getRewardListSuccess: (state, action) => {
      const { data, current_page, per_page, total } = action.payload
      state.rewardList.requesting = false
      state.rewardList.items = data
      state.rewardList.success = true
      state.rewardList.pagination.current_page = current_page
      state.rewardList.pagination.per_page = per_page
      state.rewardList.pagination.total = total
    },
    getRewardListFail: (state, action) => {
      state.rewardList.requesting = false
      state.rewardList.error = action.payload
    },
    getRewardDetails: (state) => {
      state.rewardDetails.requesting = true
      state.rewardDetails.error = null
      state.rewardDetails.data = null
      state.rewardDetails.success = false
    },
    getRewardDetailsSuccess: (state, action) => {
      state.rewardDetails.requesting = false
      state.rewardDetails.data = action.payload
      state.rewardDetails.success = true
    },
    getRewardDetailsFail: (state, action) => {
      state.rewardDetails.requesting = false
      state.rewardDetails.error = action.payload
    },
    doRewardCreate: (state) => {
      state.rewardDetails.requesting = true
      state.rewardDetails.error = null
      state.rewardDetails.data = null
      state.rewardDetails.success = false
    },
    doRewardCreateSuccess: (state, action) => {
      state.rewardDetails.requesting = false;
      state.rewardDetails.data = action.payload;
      state.rewardDetails.success = true;
    },
    doRewardCreateFail: (state, action) => {
      state.rewardDetails.requesting = false;
      state.rewardDetails.error = action.payload;
      state.rewardDetails.success = false;
    },
    doRewardUpdate: (state) => {
      state.rewardDetails.requesting = true
      state.rewardDetails.error = null
      state.rewardDetails.data = null
      state.rewardDetails.success = false
    },
     doRewardUpdateSuccess: (state, action) => {
      state.rewardDetails.requesting = false;
      state.rewardDetails.data = action.payload;
      state.rewardDetails.success = true;
    },
    doRewardUpdateFail: (state, action) => {
      state.rewardDetails.requesting = false;
      state.rewardDetails.error = action.payload;
      state.rewardDetails.success = false;
    },
    doRewardDelete: (state) => {
      state.rewardDetails.requesting = true
      state.rewardDetails.error = null
      state.rewardDetails.data = null
      state.rewardDetails.success = false
    },
    doRewardReset: (state) => {
      state.rewardDetails.data = null
    },
    getAutoRewardList: (state, action) => {
      state.autoRewardList.requesting = true
      state.autoRewardList.error = null
      state.autoRewardList.items = []
      state.autoRewardList.success = false
      state.autoRewardList.filters = action.payload
    },
    getAutoRewardListSuccess: (state, action) => {
      const { data, current_page, per_page, total } = action.payload
      state.autoRewardList.requesting = false
      state.autoRewardList.items = data
      state.autoRewardList.success = true
      state.autoRewardList.pagination.current_page = current_page
      state.autoRewardList.pagination.per_page = per_page
      state.autoRewardList.pagination.total = total
    },
    getAutoRewardListFail: (state, action) => {
      state.autoRewardList.requesting = false
      state.autoRewardList.error = action.payload
    },
    getUnAutoRewardList: (state, action) => {
      state.unautoRewardList.requesting = true
      state.unautoRewardList.error = null
      state.unautoRewardList.items = []
      state.unautoRewardList.success = false
      state.unautoRewardList.filters = action.payload
    },
    getUnAutoRewardListSuccess: (state, action) => {
      const { data, current_page, per_page, total } = action.payload
      state.unautoRewardList.requesting = false
      state.unautoRewardList.items = data
      state.unautoRewardList.success = true
      state.unautoRewardList.pagination.current_page = current_page
      state.unautoRewardList.pagination.per_page = per_page
      state.unautoRewardList.pagination.total = total
    },
    getUnAutoRewardListFail: (state, action) => {
      state.unautoRewardList.requesting = false
      state.unautoRewardList.error = action.payload
    },
  },
})

export const {
  getRewardList,
  getRewardListSuccess, doRewardCreateSuccess,
  getRewardListFail, doRewardCreateFail,
  getRewardDetails, getRewardDetailsSuccess,
  getRewardDetailsFail, doRewardCreate,
  doRewardUpdateSuccess, doRewardUpdateFail,
  doRewardUpdate, doRewardDelete,
  doRewardReset,
  getAutoRewardList, getAutoRewardListSuccess, getAutoRewardListFail,
  getUnAutoRewardList, getUnAutoRewardListSuccess, getUnAutoRewardListFail
} = rewardSlice.actions

export default rewardSlice.reducer
